// extracted by mini-css-extract-plugin
export default {"navBox":"HeaderNav_navBox__BELRn","mobile":"HeaderNav_mobile__ib-Vi","nav":"HeaderNav_nav__W1r-B","desktop":"HeaderNav_desktop__UzYr-"};